import React, { useRef, useState, useEffect } from "react";

const Stepper = ({
  steps = [],
  step = 1,
  onChangeStep = () => {},
  children,
}) => {
  const containerRef = useRef(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const activeEl = containerRef.current?.children[step - 1];
    if (!activeEl) return;

    const updateHeight = () => {
      setHeight(activeEl.offsetHeight);
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(() => {
      updateHeight();
    });

    resizeObserver.observe(activeEl);

    return () => {
      resizeObserver.disconnect();
    };
  }, [step]);

  return (
    <div className="w-full">
      <div className="flex flex-col md:flex-row md:items-center md:gap-4 mb-6">
        {steps.map((s, index) => {
          const isActive = step === s.id;
          const isDone = step > s.id;
          const isFuture = !isActive && !isDone;
          const Icon = s.icon;

          return (
            <React.Fragment key={s.id}>
              <div key={s.id} className="flex items-center">
                <div
                  className={`
                  flex items-center justify-center w-8 h-8 rounded-full text-white
                  ${isDone ? "bg-primary-500 border-primary-500" : ""}
                  ${isActive ? "bg-primary-500" : ""}
                  ${isFuture ? "bg-gray-400" : ""}
                `}
                >
                  {s.icon && <Icon className="w-5 h-5" />}
                </div>

                <div className="ml-2">
                  <p
                    className={`${isActive ? "font-semibold text-primary-500" : "text-gray-500"}`}
                  >
                    {s.title}
                  </p>
                </div>
              </div>

              {index < steps.length - 1 && (
                <div
                  className={`md:flex-1 w-[3px] ml-[15px] h-[24px] md:h-[3px] md:w-full bg-gray-300 md:mx-2 ${isDone ? "bg-primary-500" : "bg-gray-300"}`}
                />
              )}
            </React.Fragment>
          );
        })}
      </div>

      <div
        className="overflow-hidden transition-all duration-500"
        style={{ height }}
      >
        <div
          ref={containerRef}
          className="flex items-start transition-transform duration-500"
          style={{
            transform: `translateX(-${(step - 1) * 100}%)`,
          }}
        >
          {steps.map((s) => (
            <div key={s.id} className="basis-full shrink-0 py-4 self-start">
              {s.content}
            </div>
          ))}
        </div>
      </div>

      {children}
    </div>
  );
};

export default Stepper;
